export enum EnvironmentType {
  Dev = 'development',
  Local = 'local',
  Staging = 'staging',
  Production = 'production',
}
